// queries/useUploadImages.ts
"use client";
import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { fetch } from "libs";
import { UPLOAD_IMAGES_ENDPOINT } from "api";
import { UploadImagesParams } from "types";

export const useUploadImages = (): UseMutationResult<void, Error, UploadImagesParams> => {
  return useMutation<void, Error, UploadImagesParams>({
    mutationFn: async ({ username, images }): Promise<void> => {
      const formData = new FormData();

      images.forEach((image) => {
        formData.append(`images`, image);
      });

      await fetch(UPLOAD_IMAGES_ENDPOINT(username), {
        method: "POST",
        body: formData,
      });
    },
    onSuccess: () => {
      console.log("Image upload successful");
    },
    onError: (error) => {
      console.error("Error in useUploadImages:", error);
    },
  });
};

export default useUploadImages;
